__turbopack_context__.v({
  "card": "SolutionOverview-module__WG0gQW__card",
  "cardEyebrow": "SolutionOverview-module__WG0gQW__cardEyebrow",
  "cardLink": "SolutionOverview-module__WG0gQW__cardLink",
  "cardPrice": "SolutionOverview-module__WG0gQW__cardPrice",
  "cardText": "SolutionOverview-module__WG0gQW__cardText",
  "cardTitle": "SolutionOverview-module__WG0gQW__cardTitle",
  "cardTop": "SolutionOverview-module__WG0gQW__cardTop",
  "description": "SolutionOverview-module__WG0gQW__description",
  "footerButton": "SolutionOverview-module__WG0gQW__footerButton",
  "footerCard": "SolutionOverview-module__WG0gQW__footerCard",
  "footerText": "SolutionOverview-module__WG0gQW__footerText",
  "footerTitle": "SolutionOverview-module__WG0gQW__footerTitle",
  "grid": "SolutionOverview-module__WG0gQW__grid",
  "header": "SolutionOverview-module__WG0gQW__header",
  "kicker": "SolutionOverview-module__WG0gQW__kicker",
  "pointItem": "SolutionOverview-module__WG0gQW__pointItem",
  "pointList": "SolutionOverview-module__WG0gQW__pointList",
  "section": "SolutionOverview-module__WG0gQW__section",
  "title": "SolutionOverview-module__WG0gQW__title",
});
